export default __webpack_public_path__ + "static/media/filter.dae5c319.svg";